
const DropDown=()=>{
    return(
        <div>
            <button className="p-2 bg-slate-400 ">
                Update Profile
            </button>
        </div>
    )
}
export default DropDown